import * as React from 'react';

interface IRefWrapperProps {
  children: React.ReactNode | React.ReactNode[];
}

export const RefWrapper = React.forwardRef<HTMLDivElement, IRefWrapperProps>(({ children }, ref) => {
  return <div ref={ref}>{children}</div>;
});

RefWrapper.displayName = 'RefWrapper';
